import React from 'react';
import { color as palette } from "@/constants/palette";

function VerticalBar() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='2'
      height='20'
      viewBox='0 0 2 20'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.5 20V0H1.5V20H0.5Z'
        fill={palette.lineStrong}
      />
    </svg>
  );
}

export default VerticalBar;
